// theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
	palette: {
		mode: "dark",

		primary: {
			main: "#95f651", // Color primario personalizado
		},
		secondary: {
			main: "#ffff", // Color secundario personalizado
		},
	},
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					backgroundColor: "#ffff", // fondo blanco
					color: "#000000", // texto negro
					"&:hover": {
						backgroundColor: "#95f651", // fondo color primario al pasar el cursor
					},
				},
			},
		},
		MuiAccordion: {
			styleOverrides: {
				root: {
					backgroundColor: "#282828", // fondo del acordeón actualizado
				},
			},
		},
	},
});

export default theme;
